/**
 * Created by g.kosharov on 30.9.2016
 */

export default function findEntitiesByActionType(entities, actionType) {
    var result = [];
    if (entities) {
        for (var entity of entities) {
            var subentities = findDeep(entity, actionType);
            if (subentities) {
                Array.prototype.push.apply(result, subentities);
            }
        }
    }

    return result;
}

function findDeep(entity, actionType) {
    var result = [];
    if (contains(entity, actionType)) {
        result.push(entity);
    }
    var children = entity.entities;
    if (children) {
        for (var child of children) {
            var subEntities = findDeep(child, actionType);
            if (subEntities.length > 0) {
                Array.prototype.push.apply(result, subEntities);
            }
        }
    }

    return result;
}

function contains(entity, actionType) {
    let actions = entity.actions;
    return (
        actions &&
        ~actions.findIndex(element => {
            return element.actionType === actionType;
        })
    );
}
